import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=0c18374c&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=0c18374c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18374c",
  null
  
)

export default component.exports